import React from "react";

/**
 * EventHeader Component
 * 
 * Displays the event header with back button and event details
 * 
 * @param {Object} props - Component props
 * @param {Object} props.eventDetails - Event information object
 * 
 * @returns {JSX.Element} Event header UI
 */
const EventHeader = ({ eventDetails }) => {
  return (
    <div className="event-header">
      <button type="button" className="back-icon" aria-label="Go back" onClick={() => window.history.back()}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 18L9 12L15 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <div className="event-title-wrap">
        <p className="album-eyebrow">YOUR PHOTO ALBUM</p>
        <h1 className="event-title">{eventDetails?.event_name || 'Your uploaded photos'}</h1>
        <p className="event-subtitle">
          Hosted By {eventDetails?.hosted_by?.name || "Unknown"}
        </p>
      </div>
    </div>
  );
};

export default EventHeader;
